import { FileText, Landmark, type LucideIcon, Phone, Sparkles, UserRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'

function ReferencePages() {
  const { t } = useTranslation()
  return (
    <g>
      <rect
        x="44"
        y="67"
        width="146"
        height="166"
        rx="12"
        transform="rotate(-9 117 150)"
        className="fill-muted stroke-border"
      />
      <rect
        x="44"
        y="61"
        width="146"
        height="166"
        rx="12"
        transform="rotate(5 117 144)"
        className="fill-card stroke-border"
      />
      <rect
        x="36"
        y="62"
        width="146"
        height="166"
        rx="12"
        className="fill-card stroke-primary/40"
      />
      <rect x="52" y="78" width="32" height="34" rx="8" className="fill-primary/10" />
      <FileText x="59" y="85" width="18" height="20" className="text-primary-strong" />
      <text x="52" y="135" className="fill-foreground text-xs font-semibold">
        {t('schemaAgent.intro.graphic.files')}
      </text>
      <path
        d="M52 154H161 M52 165H146 M52 176H155"
        className="stroke-muted-foreground/20"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <rect x="52" y="194" width="33" height="18" rx="4" className="fill-muted" />
      <rect x="92" y="194" width="33" height="18" rx="4" className="fill-muted" />
      <text x="59" y="206" className="fill-muted-foreground text-3xs font-medium">
        PDF
      </text>
      <text x="99" y="206" className="fill-muted-foreground text-3xs font-medium">
        CSV
      </text>
    </g>
  )
}

function SchemaNode({ node }: { node: { x: number; y: number; label: string; icon: LucideIcon } }) {
  const Icon = node.icon
  return (
    <g transform={`translate(${node.x} ${node.y})`}>
      <rect width="156" height="54" rx="12" className="fill-card stroke-primary/40" />
      <rect x="10" y="10" width="34" height="34" rx="9" className="fill-primary/10" />
      <Icon x="18" y="18" width="18" height="18" className="text-primary-strong" />
      <text x="54" y="32" className="fill-foreground text-xs font-medium">
        {node.label}
      </text>
    </g>
  )
}

export function SchemaAgentIntroIllustration() {
  const { t } = useTranslation()
  return (
    <svg
      viewBox="0 0 680 300"
      role="img"
      aria-label={t('schemaAgent.intro.graphic.description')}
      className="block w-full"
    >
      <circle cx="374" cy="147" r="141" className="fill-primary/5" />
      <circle cx="374" cy="147" r="111" className="fill-none stroke-primary/10" />
      <path
        d="M184 145H248 M296 145H313Q330 145 330 128V87Q330 74 344 74H365 M443 101V127Q443 142 458 142H564V161 M443 127V211H405"
        className="fill-none stroke-primary/50"
        strokeWidth="1.5"
      />
      <circle cx="443" cy="127" r="4" className="fill-primary" />
      <ReferencePages />
      <rect
        x="239"
        y="112"
        width="66"
        height="66"
        rx="23"
        className="fill-primary/10 stroke-primary/20"
      />
      <rect x="247" y="120" width="50" height="50" rx="17" className="fill-foreground" />
      <Sparkles x="259" y="132" width="26" height="26" className="text-background" />
      <text
        x="272"
        y="199"
        textAnchor="middle"
        className="fill-primary-strong text-2xs font-semibold"
      >
        {t('schemaAgent.title')}
      </text>
      <SchemaNode
        node={{ x: 365, y: 47, label: t('schemaAgent.intro.graphic.person'), icon: UserRound }}
      />
      <SchemaNode
        node={{ x: 486, y: 161, label: t('schemaAgent.intro.graphic.account'), icon: Landmark }}
      />
      <SchemaNode
        node={{ x: 327, y: 211, label: t('schemaAgent.intro.graphic.phone'), icon: Phone }}
      />
      <text x="490" y="132" className="fill-muted-foreground text-3xs">
        {t('schemaAgent.intro.graphic.holds')}
      </text>
      <text x="366" y="183" className="fill-muted-foreground text-3xs">
        {t('schemaAgent.intro.graphic.uses')}
      </text>
    </svg>
  )
}
